"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
const InputField_1 = __importDefault(require("./InputField"));
const api_1 = require("../api");
const Button_1 = __importDefault(require("./Button"));
const Presets_1 = require("../Pages/Presets");
const NewPresetForm = (props) => {
    const presetApi = new api_1.PresetApi();
    const values = {
        column: props.column || '',
        grid_model: 'plant',
        value: '',
    };
    const onSubmit = async (values, { setErrors, setSubmitting }) => {
        try {
            const { success, item } = await presetApi.create(values);
            if (success && props.handleCreated)
                props.handleCreated(item);
        }
        catch (error) {
            setErrors(error.response.data.errors);
        }
        setSubmitting(false);
    };
    return (react_1.default.createElement(formik_1.Formik, { initialValues: values, onSubmit: onSubmit }, ({ isSubmitting }) => (react_1.default.createElement(formik_1.Form, { className: "space-y-4" },
        react_1.default.createElement("div", { className: "" },
            "Spalte ",
            (0, Presets_1.getPresetNames)(props.column)),
        react_1.default.createElement(InputField_1.default, { name: "value", type: "text", label: "Neuer Wert" }),
        react_1.default.createElement("div", { className: 'flex justify-between' },
            react_1.default.createElement(Button_1.default, { onClick: props.handleCancel, type: 'button', variant: "secondary" }, "Abbrechen"),
            react_1.default.createElement(Button_1.default, { type: "submit", disabled: isSubmitting }, "Speichern"))))));
};
exports.default = NewPresetForm;
